import http from '../../base/api/public.js'

let service = require('@/../config/serviceList')
let sysConfig = require('@/../config/sysConfig')
let apiPre = sysConfig.apiPre

export default {
  //获取省
  getProvinces() {
    return http.requestGet(apiPre + service.ops + '/ops/areaAddress/getProvinces', {})
  },
  //根据省id获取市/根据市id获取区
  getAreas(id) {
    return http.requestGet(apiPre + service.ops + '/ops/areaAddress/getAreas/' + id, {})
  },
  //省市区三级联动
  getAllAreas() {
    return http.requestGet(apiPre + service.ops + '/ops/areaAddress/getAll', {})
  },
  // 获取所有运营商
  getOperators() {
    return http.requestPost(apiPre + service.member + '/member/operator/listForSelect', {})
  },
  // 获取所有运营商且运营商不过滤
  getOperatorsNotFilter() {
    return http.requestPost(apiPre + service.member + '/member/operator/listForSelectNotFilter', {})
  },
  // 获取所有运营商且运营商不过滤
  getOperatorsTreeNotFilter() {
    return http.requestPost(apiPre + service.member + '/member/operator/listForTreeNotFilter', {})
  },
  // 获取站点
  getStations(param = {}) {
    return http.requestPost(apiPre + service.res + '/res/station/stationsForSelect', param)
  },
  stationList(param) {
    return http.requestPost(apiPre + service.res + '/res/station/stationsForSelectByOperatorId',param)
  },
  // 获取费率
  getRates(param) {
    return http.requestPost(apiPre + service.res + '/res/rate/ratesForSelect', param)
  },
  // 根据手机号模糊匹配客户信息
  getCustomers(param) {
    return http.requestPost(apiPre + service.member + '/member/customer/getListByPhone/' + param, {})
  },
  // 根据手机号模糊匹配客户信息
  getPhoneListByPhone(param) {
    return http.requestPost(apiPre + service.member + '/member/customer/getPhoneListByPhone' , param)
  },
  getGroups(param) {
    return http.requestPost(apiPre + service.member + '/member/group/listForSelect', param)
  },
  // 运营商，集团级联查询
  getGroupWithOperator() {
    return http.requestPost(apiPre + service.member + '/member/group/ListWithOperator', {})
  },
  getStationByCodes(codes) {
    return http.requestPostKeyValue(apiPre + service.res + '/res/station/listByCodes', {codes: codes})
  },
  getStationByIds(ids) {
    return http.requestPostKeyValue(apiPre + service.res + '/res/station/listByIds', {ids: ids})
  },
  getCustomerByIds(list) {
    return http.requestPostKeyValue(apiPre + service.member + '/member/customer/listByIds', {list: list})
  },
  getGroupCustomer(param) {
    return http.requestPost(apiPre + service.member + '/member/groupCustomer/listForSelect', param)
  },
  getUserByUser(param) {
    return http.requestPost(apiPre + service.rbac + '/rbac/user/getByUser', param)
  },
  getOperatorToStation(){
    return http.requestQuickGet(apiPre+service.res + '/res/station/operatorToStation')
  },
  // 获取树列表
  getOperatorsTree(params){
    return http.requestPost(apiPre + service.member + '/member/operator/listForSelectTree', params)
  },
  // 获取站点
  searchList(params){
    return http.requestGet(apiPre + service.member + '/member/re/operatorUserStation/searchList?' + params, {})
  },
  // getOperatorsTree(params){
  //   return http.requestPost(apiPre + service.member + '/member/operator/listForSelectTree', params)
  // },
  // pilesForSelect(params) {
  //   console.log('params:' + JSON.stringify(params))
  //   return http.requestPost(apiPre + service.res + '/res/pile/pilesForSelect', params)
  // },
  getCompanyCodeAndName() {
    return http.requestQuickGet(apiPre + service.res + '/res/cecCompanyInfo/companyCodeAndName')
  },
}



// WEBPACK FOOTER //
// ./src/common/api/commonApi.js